import { FeatureSection } from '../FeatureSection';
import {
  ArticleHeroMedia,
  articleHasHeroMedia,
} from '../article/ArticleHeroMedia';
import { featureArticleHref } from '../../lib/featureArticles';
import type { ArticleRow } from '../../../../shared/schemas/article';

interface FeatureArticleLargeProps {
  article: ArticleRow;
  imagePosition: 'left' | 'right';
}

export function FeatureArticleLarge({ article, imagePosition }: FeatureArticleLargeProps) {
  const hasHeroMedia = articleHasHeroMedia({
    hero_media: article.hero_media,
    mini_demo_id: article.mini_demo_id,
  });

  return (
    <FeatureSection
      title={article.title}
      description={article.excerpt ?? ''}
      imagePosition={imagePosition}
      linkHref={featureArticleHref(article.slug)}
      linkLabel="Learn more"
    >
      {hasHeroMedia ? (
        <ArticleHeroMedia
          heroMedia={article.hero_media ?? undefined}
          legacyMiniDemoId={article.mini_demo_id}
          demoFallbackClassName="h-full w-full"
        />
      ) : undefined}
    </FeatureSection>
  );
}
